import { useTranslation } from '@packlink/translation-provider';
import { InlineNotification, NotificationType, Next, Typography } from '@shipengine/giger';
import { useHelpCenter, HELP_CENTER_KEYS } from '@packlink/provider';
import { jsx } from '@emotion/react/jsx-runtime';

const InsuranceInformation = _ref => {
  let {
    imageUrl
  } = _ref;
  const getHelpCenterPage = useHelpCenter();
  const {
    t
  } = useTranslation();
  return jsx(InlineNotification, {
    title: t('insurance-selector.insurance-information.title'),
    type: NotificationType.INFO,
    coloredTitle: false,
    src: imageUrl,
    actionElement: jsx(Next.Link, {
      href: getHelpCenterPage(HELP_CENTER_KEYS.insurance),
      target: "_blank",
      children: jsx(Typography, {
        variant: "body2",
        bold: true,
        children: t('insurance-selector.insurance-information.read-more')
      })
    }),
    children: t('insurance-selector.insurance-information.main-text')
  });
};

export { InsuranceInformation };
//# sourceMappingURL=InsuranceInformation.js.map
